var icons = {
    paperlessIcon: "/paperlessIcon.svg",
    noStatementIcon: "/NoStatementIcon.svg",
    errorIcon: "/ErrorIcon.svg",
    statementsDownIcon: "/StatementsDownIcon.svg",
};
export default icons;
